export const getInitialThreadVentureValues = date => ({
  type: 'TWITTER_THREADVENTURE',
  status: 'draft',
  startDate: date,
  endDate: date,
  actions: [],
  threadVentureExport: '[]',
  store: false,
  profanity: false,
  lock: false
})



// WEBPACK FOOTER //
// ./src/pages/widgets/thread_venture/create/container/initialValues.js